import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, browserLocalPersistence, browserSessionPersistence } from "firebase/auth";

const app = initializeApp({
  apiKey: 'AIzaSyBiEcsqmO_5He-LscgXVQd13DX4Rp26Npc',
  authDomain: 'sg-library.firebaseapp.com',
  databaseURL: 'https://sg-library.firebaseio.com',
  projectId: 'sg-library',
  storageBucket: 'sg-library.appspot.com',
  messagingSenderId: '327758575997'
});

export const db = getFirestore(app);

export const auth = getAuth(app);
export const AUTH_PERSISTANCE_LOCAL = browserLocalPersistence;
export const AUTH_PERSISTANCE_SESSION = browserSessionPersistence;

export const storage = getStorage(app);
